import { Injectable } from '@angular/core';

import { BitfStorageService } from '@bitf/services/storage/bitf-storage.service';
import { CouponEvent } from '@common/core/models/coupon-event.model';

import { Storage } from '@models';

@Injectable({
  providedIn: 'root',
})
export class StorageService extends BitfStorageService<Storage> {
  constructor() {
    super({
      nativeStorage: localStorage,
      storageKey: 'storage',
      storageClass: Storage,
      initialData: { readNewsIds: [], baseAdfsUrl: '', couponEvent: null },
    });
  }
}
